<script type="text/jsx">
import BuyNow from './buy-now.vue';
import Trial2Paid from './trial-to-paid.vue';
import BuyTrial from './buy-trial.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.buyTrial) return <BuyTrial />;
    if (this.$context.is.trial2paid) return <Trial2Paid {...{ props: { ...this.$props } }}
                                                                              on={this.$listeners} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{ props: { ...this.$props } }}
                                                                              on={this.$listeners} />;
    return null;
  },
};
</script>
